import { StepSection } from '@/components/StepSection/StepSection';

import styles from './SelectDataFileInformationSection.module.css';

interface Step {
  index: number;
  image: string;
  title: string;
  description: string;
}

interface SelectDataFileSectionProps {
  steps: Step[];
}

export const SelectDataFileInformationSection = ({ steps }: SelectDataFileSectionProps) => {
  return (
    <div className={styles.panel}>
      {steps.map((step) => (
        <StepSection
          description={step.description}
          image={step.image}
          index={step.index}
          key={step.index}
          title={step.title}
        />
      ))}
    </div>
  );
};
